import Item from "sap/ui/core/Item";
import ListItem from "sap/ui/core/ListItem";

export function BetterComboBoxItemFilterFunction(
  sTerm?: string,
  oItem?: Item | ListItem
) {
  if (!sTerm || !oItem) return true;
  const regex = new RegExp(sTerm, "i");
  const oListItem = oItem as ListItem;

  // A case-insensitive 'string contains' filter
  return !!(
    oItem.getText().match(regex) ||
    (oListItem.getAdditionalText && oListItem.getAdditionalText().match(regex))
  );
}
